import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import i18n from '../../utils/i18n';
import Pill from '@adsk/bim360-matrix-react-pill';

const StatusPill = ({status, className}) => {
  const pillClasses = cx('StatusPill', className, `IssueStatus__${status}`);

  return <Pill className={pillClasses} label={i18n.t(`status.${status}`)} />;
};

StatusPill.displayName = 'StatusPill';

StatusPill.propTypes = {
  status: PropTypes.string.isRequired,
  className: PropTypes.string
};

export default StatusPill;
